import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import DeleteIcon from '@mui/icons-material/Delete'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import EditIcon from '@mui/icons-material/Edit'
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useLayoutEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import PDFViewer from 'Charts/PDFViewer'
import DataTable from 'Charts/tb'
import { annullamentoPratica } from 'services/annullamentoPratica'
import { downloadDocument } from 'services/downloadDocument'
import { getIndicatoriAdvAutomatica } from 'services/getIndicatoriAdvAutomatica'
import { getPraticheDettaglio } from 'services/getPraticheDettaglio'
import { updateFolder } from 'services/updateFolder'
import CustomModal from 'UI/CustomModal'
import Footer from 'UI/Footer'
import Header from 'UI/Header'
import { StatiPratica } from 'enums/stati-pratica'
import AccordionDettaglio from 'pages/components/AccordionDettaglio'
import AdeguataVerificaFormModal from 'pages/components/AdeguataVerificaFormModal'
import DocumentiOpzionaliModal from 'pages/components/DocumentiOpzionaliModal';

const Dettaglio = ({ note }) => {
  const theme = useTheme()
  const modalTableStyle = {
    position: 'absolute',
    top: '20',
    left: '20',
    transform: 'translate(10%, 10%)',
    width: '1300px',
    mb: '200px',
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 0,
    p: 2,
    borderRadius: 2,
  }
  const tableStyle = {
    transform: 'translate(30%, -40%)',
    maxHeight: 800,
    width: 900,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 20,
    borderRadius: 2,
  }
  const location = useLocation()
  console.log(location.state.selectedRowData.id)

  const {
    data: indicatoriPratica,
    isFetched: isFetchedIndicatoriPratica,
    error: errorIndicatoriPratica
  } = useQuery({
    queryKey: ['indicatori_Pratica', location.state?.selectedRowData.id],
    queryFn: () => getIndicatoriAdvAutomatica(location.state?.selectedRowData.id),
    enabled:
      location.state?.selectedRowData.tipoInserimento === 'Automatica' || location.state?.selectedRowData.tipoInserimento === 'Automatica Medio Rischio' || location.state?.selectedRowData.tipoInserimento === 'Automatica Alto Rischio',
    retry: false
  },
  )

  const [startPol, setStartPol] = useState(false)
  const [open, setOpen] = useState(false)
  const [showDuplicaAdv, setShowDuplicaAdv] = useState(false)
  const [loading, setLoading] = useState(false)
  const [disabledButton, setDisabledButton] = useState(false)
  const [openCustomModal, setOpenCustomModal] = useState(false)
  const [refetchPostUpdateFolder, setRefetchPostUpdateFolder] = useState(false)
  const [idPraticaDuplicata, setIdPraticaDuplicata] = useState('')
  const [valoriPraticaDuplicata, setValoriPraticaDuplicata] = useState(undefined)

  const [showPDF, setShowPDF] = useState({
    cartaIdentita: false,
    listeAML_MASI: false,
    listeAML_SCARPELLI: false,
    protestiDiBrisco: false,
    protestiScarpelli: false,
    TEEsquad: false,
    VisuraEsquad: false,
    camerale: false,
    sociEsponenti: false,
    paolo_scaroni: false,
    starfire: false,
    starfireServices: false,
  })

  const [formValues, setFormValues] = useState({
    NDG: undefined,
    ragioneSociale: undefined,
    codiceFiscale: undefined,
    indirizzo: undefined,
    nazione: undefined,
    dataUltima: undefined,
    esito: undefined,
    note: undefined,
  })
  const [refetchInterval, setRefetchInterval] = useState(0)

  const navigate = useNavigate()

  useEffect(() => {

    if (refetchPostUpdateFolder === true) {

      setRefetchInterval(1000)
      setTimeout(function () {
        setRefetchInterval(0)
        setRefetchPostUpdateFolder(false)
      }, 4000)
    }
  }, [refetchPostUpdateFolder])

  const handleOpen = () => setOpen(true)
  const [openModal, setOpenModal] = useState(false)

  const [statoRichiesta, setStatoRichiesta] = useState(
    location.state?.selectedRowData.statoPratica
  )

  const [valoriModale, setValoriModale] = useState(
    location.state?.selectedRowData,
  )
  const [errorState, setErrorState] = useState(false)
  const [loadingModal, setLoadingModal] = useState(false)
  const [infoMessage, setInfoMessage] = useState('')
  const [errorCF, setErrorCF] = useState(false)
  const [listaPratiche, setListaPratiche] = useState([])

  const [responseIndirizzo, setResponseIndirizzo] = useState('')
  const [responseRagioneSociale, setResponseRagioneSociale] = useState('')
  const [responseCodiceFiscale, setResponseCodiceFiscale] = useState('')
  const [responseNazione, setResponseNazione] = useState('')
  const [responseNdg, setResponseNdg] = useState('')
  const [responseRelazione, setResponseRelazione] = useState('')
  const [responseDettaglioRelazione, setResponseDettaglioRelazione] =
    useState('')
  const [openModalDocumentiOpzionali, setOpenModalDocumentiOpzionali] = useState(false);

  const {
    data: praticheDettaglio,
    isFetching: isFetchingPraticheDettaglio,
    isLoading: isLoadingPraticheDettaglio,
    isFetched: isFetchedPraticheDettaglio,
    refetch: refetchPraticheDettaglio,
  } = useQuery(
    ['pratiche_dettaglio', location.state?.selectedRowData.id],
    () => getPraticheDettaglio(location.state?.selectedRowData.id),
    { refetchInterval: refetchInterval },
  )

  useEffect(() => {
    if (praticheDettaglio && praticheDettaglio.length > 0) {
      const lastPratica = praticheDettaglio[praticheDettaglio.length - 1]
      setResponseIndirizzo(lastPratica['indirizzo'] || '')
      setResponseRagioneSociale(lastPratica['ragioneSociale'] || '')
      setResponseCodiceFiscale(lastPratica['codiceFiscale'] || '')
      setResponseNazione(lastPratica['nazione'] || '')
      setResponseNdg(lastPratica['ndg'] || '')
      setResponseRelazione(lastPratica['relazione'] || '')
      setResponseDettaglioRelazione(lastPratica['dettaglioMotivazione'] || '')
      setValoriModale(lastPratica)
    }
  }, [praticheDettaglio])

  const addPraticaToDettaglio = pratica => {

    if (praticheDettaglio) {
      setListaPratiche(buildListaPratiche([...praticheDettaglio, pratica]))
      setRefetchPostUpdateFolder(true)
      setShowDuplicaAdv(false)
    }
  }

  const buildListaPratiche = pratiche => [...new Map(pratiche.filter(p => p).map(p => [p.id, p])).values()]


  useEffect(() => {
    if (listaPratiche && listaPratiche?.length > 1) {
      for (var i = 0; i < listaPratiche?.length; i++) {
        if (listaPratiche[i].statoRichiesta === "In Richiesta" ||
          listaPratiche[i].statoRichiesta === "In Lavorazione") {
          setIdPraticaDuplicata(listaPratiche[i]?.entry?.id)
          setValoriPraticaDuplicata(listaPratiche[i].entry?.properties)
          setShowDuplicaAdv(false)
        }
        else if (listaPratiche[listaPratiche?.length - 1].statoRichiesta === StatiPratica.chiusa
        ) {
          setShowDuplicaAdv(true)
        }
      }
    }

    else if (listaPratiche && praticheDettaglio && listaPratiche?.length !== praticheDettaglio?.length) {
      for (var i = 0; i < praticheDettaglio?.length; i++) {
        if (praticheDettaglio[praticheDettaglio?.length - 1]?.statoRichiesta === StatiPratica.chiusa) {
          setShowDuplicaAdv(true)
        }
      }
    }
  }, [listaPratiche, addPraticaToDettaglio]
  )

  useEffect(() => {
    const atLeastOneClosed =
      praticheDettaglio &&
      praticheDettaglio.filter(
        pratica =>
          pratica && pratica.entry?.dataChiusura,
      ).length > 0

    if (praticheDettaglio) {
      setListaPratiche(buildListaPratiche([...listaPratiche, ...praticheDettaglio]))

    }

  }
    , [praticheDettaglio])

  function handleReloadDettaglio() {
    debugger
    window.location.reload()
  }

  function handleAnnullaPratica() {

    annullamentoPratica(location.state?.selectedRowData.id).then(response => {
      if (response.data.code === 200) {

        setOpenCustomModal(true)
        setErrorState(false)
        setInfoMessage(`Annullamento avvenuto con successo`)
        setTimeout(function () {
          setOpenCustomModal(false)
          navigate('/')
        }, 4000)
      }
    }).catch(error => {

      setOpenCustomModal(true)
      setErrorState(true)
      if (error.response.data.code !== 200) {
        setInfoMessage(error.response.data.message)
        setErrorCF(true)
      } else {
        setInfoMessage(`Errore durante l'annullamento della pratica`)
      }
      setTimeout(function () {
        setOpenCustomModal(false)
      }, 4000)
    })
  }


  const handleModifica = (event, params) => {
    params = Object.assign({ ...params, statoRichiesta: statoRichiesta });

    if (params !== undefined) {
      const isAutomatica = params.tipoInserimento && params.tipoInserimento.includes('Automatica');

      if (
        (!isAutomatica && params.NDG === '') ||  // Controlla NDG solo se non è 'Automatica'
        params.ragioneSociale === '' ||
        // params.Citta === '' ||
        // params.indirizzo === '' ||
        // params.nazione === '' ||
        params.daAssegnare === '' ||
        params.daAssegnare === null
      ) {
        setInfoMessage('COMPLETARE CAMPI OBBLIGATORI');
        setOpenCustomModal(true);
        setErrorState(true);
        setTimeout(function () {
          setInfoMessage('');
          setOpenCustomModal(false);
        }, 4000);
      } else if (
        (params.relazione !== undefined || params.relazione !== null || params.relazione !== '') &&
        (params.relazione.includes('Altro')) &&
        (params.dettaglioRelazione === null || params.dettaglioRelazione?.trim() === '')
      ) {
        setInfoMessage('Inserire dettaglio della relazione');
        setOpenCustomModal(true);
        setErrorState(true);
        setTimeout(function () {
          setInfoMessage('');
          setOpenCustomModal(false);
        }, 4000);
      } else if (
        (params.codiceFiscale?.trim() === '' || !params.codiceFiscale) &&
        (params.nazione?.trim().toLowerCase() === 'it' ||
          params.nazione?.trim().toLowerCase() === 'italia')
      ) {
        setInfoMessage('Completare Codice Fiscale');
        setOpenCustomModal(true);
        setErrorState(true);
        setTimeout(function () {
          setInfoMessage('');
          setOpenCustomModal(false);
        }, 1000);
      } else if (params.ragioneSociale.length > 100) {
        setInfoMessage('Ragione Sociale non può contenere più di 100 caratteri!');
        setOpenCustomModal(true);
        setErrorState(true);
        setTimeout(function () {
          setInfoMessage('');
          setOpenCustomModal(false);
        }, 4000);
      } else {

        setInfoMessage('Salvataggio in corso');
        setOpenCustomModal(true);
        setLoading(true);
        updateFolder(params)
          .then(response => {
            if (response.data.code === 200) {
              setRefetchPostUpdateFolder(true);
              setDisabledButton(true);
              setOpenCustomModal(true);
              setLoading(false);
              setErrorState(false);
              setInfoMessage(response.data.message);
              setValoriModale(response.data.body.properties);
              setFormValues({
                ...formValues,
                [formValues.dettaglioRelazione]:
                  response.data.body.dettaglioMotivazione,
              });
              setResponseIndirizzo(response.data.body.indirizzo);
              setResponseRagioneSociale(response.data.body.ragioneSociale);
              setResponseDettaglioRelazione(response.data.body.dettaglioMotivazione);
              setResponseCodiceFiscale(
                !response.data.body.codiceFiscale
                  ? ''
                  : response.data.body.codiceFiscale,
              );
              setResponseNazione(response.data.body.nazione);
              setResponseNdg(response.data.body.ndg);
              setResponseRelazione(response.data.body.relazione);

              setTimeout(function () {
                setOpenCustomModal(false);
                setInfoMessage('')
              }, 3000);

              setTimeout(function () {
                setInfoMessage('')
                setOpenModal(false);
                setDisabledButton(false);
              }, 2000);
            }
          })
          .catch(error => {
            setLoadingModal(false);
            setErrorState(true);
            if (error.response.data.code === 403) {
              setInfoMessage(error.response.data.message);
              setLoadingModal(false);
              setErrorCF(true);
            } else {
              setInfoMessage(error.response.data.message);
            }
            setTimeout(function () {
              setOpenCustomModal(false);
              setInfoMessage('')
              setErrorState(false)
            }, 3000);
          });
      }
    }
  };


  const handleOpenModal = () => setOpenModal(!openModal)

  const [pdfData, setPdfData] = useState(undefined)


  useLayoutEffect(() => {
    setFormValues({
      ragioneSociale:
        location.state?.selectedRowData.ragioneSociale,
      NDG: location.state?.selectedRowData.ndg,

      gruppoUtenteCreatore: location.state?.selectedRowData.utenteCreatore,

      codiceFiscale:
        location.state?.selectedRowData.codiceFiscale,
      indirizzo:
        location.state?.selectedRowData.indirizzo,
      nazione:
        location.state?.selectedRowData.nazione,

      dataUltima: location.state?.selectedRowData.dataUltima,

      documentiOpzionaliVari:
        location.state.selectedRowData.documentiOpzionaliVari,

      esito: location.state?.selectedRowData.esito,

      note: location.state?.selectedRowData.note,
    })
    return () => {
      setFormValues({
        ragioneSociale: undefined,
        codiceFiscale: undefined,
        indirizzo: undefined,
        nazione: undefined,
        dataUltima: undefined,
        esito: undefined,
        note: undefined,
      })
    }
  }, [formValues.ragioneSociale])

  useLayoutEffect(() => handleOpen(), [showPDF])

  const clickDoc = (event, idFile, filename) => {

    event.preventDefault()

    if (!pdfData || pdfData.title !== filename)
      downloadDocument(idFile, false).then(res =>
        setPdfData({ title: filename, document: res }),
      )
    else setPdfData(undefined)
  }

  const copiaRagioneSociale = () => {
    navigator.clipboard.writeText(formValues.ragioneSociale).then(function () {
    })
  }


  const syncStatoRichiesta = statoRichiesta => {
    setStatoRichiesta(statoRichiesta)
  }


  const openAdvAutomatica = startPol => {
    setStartPol(!startPol)
  }

  const handleCloseModalDocumentiOpzionali = () => {
    setOpenModalDocumentiOpzionali(false);
  }


  return (
    <>
      <Header
        showHome
        showRichiesta={false}
        showDuplicaAdv={showDuplicaAdv}
        idNodoPratica={location.state?.selectedRowData.id}
        praticaProperties={
          praticheDettaglio
            ? praticheDettaglio[0]
            : location.state?.selectedRowData
        }
        addPraticaToDettaglio={addPraticaToDettaglio}
        header={
          <Box
            sx={{
              flexDirection: 'row',
              width: '80%',
              justifyContent: 'flex-end',
              display: 'flex',
              gap: '8px',
              mt: '4rem',
              height: '75px'
            }}
          ><>
              <Box
                sx={{
                  marginBottom: '1rem',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'space-between',
                  display: 'flex',
                }}
              >
                <Box
                  sx={{
                    flexDirection: 'row',
                    width: '80%',
                    justifyContent: 'space-between',
                    display: 'flex',
                    mr: '10px',
                    ml: '155px',
                  }}
                >
                  <Tooltip title={responseRagioneSociale} >
                    <Box item xs={3} sx={{ flexDirection: 'row' }}>
                      <TextField
                        disabled
                        value={responseRagioneSociale}
                        id="standard-basic"
                        helperText={
                          <Typography variant="caption">
                            Ragione Sociale
                          </Typography>
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment
                              position="start"
                              sx={{ cursor: 'pointer' }}
                            >
                              <ContentCopyIcon onClick={copiaRagioneSociale} />
                            </InputAdornment>
                          ),
                        }}
                        variant="standard"
                        sx={{ width: '95%' }}
                      />
                    </Box>
                  </Tooltip>
                  <Tooltip title={responseCodiceFiscale} >
                    <Box sx={{ flexDirection: 'row' }}>
                      <TextField
                        disabled
                        value={responseCodiceFiscale}
                        id="standard-basic"
                        helperText="Codice Fiscale"
                        variant="standard"
                        sx={{ width: '95%' }}
                      />
                    </Box>
                  </Tooltip>

                  <Tooltip title={responseIndirizzo} >
                    <Box sx={{ flexDirection: 'row' }}>
                      <TextField
                        disabled
                        value={responseIndirizzo}
                        id="standard-basic"
                        helperText="Indirizzo"
                        variant="standard"
                        sx={{ width: '95%' }}
                      />
                    </Box>
                  </Tooltip>

                  <Tooltip title={responseNazione} >
                    <Box sx={{ flexDirection: 'row' }}>
                      <TextField
                        disabled
                        value={responseNazione}
                        id="standard-basic"
                        helperText="Nazione"
                        variant="standard"
                        sx={{ width: '95%' }}
                      />
                    </Box>
                  </Tooltip>
                  <Tooltip title={responseNdg} >
                    <Box sx={{ flexDirection: 'row' }}>
                      <TextField
                        disabled
                        value={responseNdg}
                        id="standard-basic"
                        helperText="NDG"
                        variant="standard"
                        sx={{ width: '95%' }}
                      />
                    </Box>
                  </Tooltip>

                </Box>
                <Box
                  sx={{ display: 'flex', alignItems: 'flex-start', mr: '75px' }}
                  direction={'row'}
                >
                  <Tooltip title={"Annulla la pratica"}>
                    <IconButton
                      onClick={handleAnnullaPratica}
                      disabled={
                        (statoRichiesta !== StatiPratica.IN_LAVORAZIONE.stato &&
                          statoRichiesta !== StatiPratica.IN_RICHIESTA.stato) ||
                        statoRichiesta === StatiPratica.ANNULLATA.stato
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title={"Apre schermata di modifica pratica"}>
                    <IconButton
                      onClick={handleOpenModal}
                      disabled={
                        (statoRichiesta !== StatiPratica.CHECK_OUT_OPERATORE.stato &&
                          statoRichiesta !== StatiPratica.INFO_COMPLETE.stato &&
                          statoRichiesta !== StatiPratica.IN_LAVORAZIONE.stato &&
                          statoRichiesta !== StatiPratica.IN_RICHIESTA.stato) ||
                        statoRichiesta === StatiPratica.ANNULLATA.stato
                      }
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title={"Apre schermata per la richiesta di documenti opzionali"}>
                    <IconButton
                      onClick={() => setOpenModalDocumentiOpzionali(prevState => !prevState)}
                      disabled={statoRichiesta === StatiPratica.ANNULLATA.stato || statoRichiesta === StatiPratica.CHIUSA.stato}
                    >
                      <DriveFolderUploadIcon />
                    </IconButton>
                  </Tooltip>


                </Box>
              </Box></>
          </Box>
        }
      />

      <Grid
        item
        container
        xs={12}
        direction="row"
        justifyItems="space-between"
        alignItems="flex-start"
      ><>
          <Grid item xs={7}><>
            <Stack sx={{ alignItems: 'center' }}>
              {isFetchingPraticheDettaglio && (
                <CircularProgress></CircularProgress>
              )}
              {isFetchedPraticheDettaglio &&
                praticheDettaglio
                  .map(pratica => (
                    <>
                      <AccordionDettaglio
                        openTableState={startPol}
                        idNodoPratica={pratica?.id}
                        dettaglioPratica={pratica}
                        clickDoc={clickDoc}
                        valueRelazioneModal={pratica?.relazione}
                        valueNDGModal={pratica?.ndg}

                        {...{ isFetchedIndicatoriPratica, errorIndicatoriPratica, indicatoriPratica, openAdvAutomatica, refetchPostUpdateFolder, syncStatoRichiesta, refetchPraticheDettaglio, handleReloadDettaglio }}
                      />
                    </>
                  ))}
            </Stack></>
          </Grid>
          <Footer
            idPratica={location.state.selectedRowData.id}
          />

          {pdfData && (
            <Grid
              item
              xs={5}
              component="div"
              sx={{ overflow: 'auto', maxWidth: '50%', maxHeight: '50%' }}
            ><>
                <PDFViewer document={pdfData.document} title={pdfData.title} />
              </>
            </Grid>
          )}

          <Modal
            hideBackdrop
            open={openModal}
            s sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              height: '550px',
              width: '900px',
              transform: 'translate(-50%, -50%)',
              maxWidth: '80vw',
              maxHeight: '80vh',
              overflowY: 'auto',
              border: '1px solid #000',
              boxShadow: 0,
              p: 2,
              backgroundColor: '#ffff',
              paddingTop: '0px',
            }}
          ><>
              <AdeguataVerificaFormModal
                idNodoPratica={idPraticaDuplicata ? idPraticaDuplicata : location.state?.selectedRowData.id}
                loading={loading}
                statoPratica={statoRichiesta}
                disabledButton={disabledButton}
                defaultValues={valoriPraticaDuplicata ? valoriPraticaDuplicata : valoriModale}
                onClick={(event, params) => handleModifica(event, params)}
                errorState={errorState}
                errorCF={errorCF}
                responseDettaglioRelazione={responseDettaglioRelazione}
                handleViewModal={() => setOpenModal(false)}
              /></>
          </Modal>
          <CustomModal
            open={openCustomModal}
            loading={loading}
            error={errorState}
            message={infoMessage} />
        </>
        {isFetchedPraticheDettaglio &&
          <DocumentiOpzionaliModal
            documentiOpzionaliInPratica={praticheDettaglio[praticheDettaglio.length - 1].documentiOpzionaliVari}
            motivazioneRichiesteOpzionali={praticheDettaglio[praticheDettaglio.length - 1].motivazioneRichiesteOpzionali}
            idPratica={location.state?.selectedRowData.id}
            {...{ openModalDocumentiOpzionali, handleCloseModalDocumentiOpzionali, refetchPraticheDettaglio }}
          />
        }

      </Grid>
      {startPol && (
        <Paper
          variant="outlined"
          sx={tableStyle}
          onMouseLeave={openAdvAutomatica}
          square
        >
          <DataTable indicatoriPratica={indicatoriPratica}></DataTable>
        </Paper>
      )}
    </>
  )
}
export default Dettaglio
